export default "__VITE_ASSET__74e63092__"